"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIDEBAR_ICON_BUTTON_WIDTH = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
/**
 * Constant defining the width of the button.
 * This is also used when calculating the width of container.
 *
 * Value is in px.
 * 56 comes from material ui
 */
exports.SIDEBAR_ICON_BUTTON_WIDTH = 56;
/**
 *
 * This component is only intended to be used internally in mui5
 *
 * @internal
 */
const SidebarIconButton = react_1.default.forwardRef((props, ref) => {
    // @ts-expect-error Not all props form ISidebarIconButtonProps can be passed to a `a` component. Filtering out unsupported props.
    const { sx, fullWidth, textColor, indicator, selectionFollowsFocus, ...rest } = props;
    return (react_1.default.createElement(IconButton_1.default, { component: "a", sx: [{ p: 2 }, ...(Array.isArray(sx) ? sx : [sx])], ...rest, 
        // @ts-expect-error The ref type of IconButton cannot handle that the button can get a anchor element or a button element
        ref: ref }));
});
exports.default = SidebarIconButton;
